import { EPlacingType } from '../../types/reducers/publishTerms';
import { actionGenerator, IReduxAction } from '../../utils/actions';

export const CHANGE_PLACING_TYPE = 'PUBLISH_TERMS :: CHANGE_PLACING_TYPE';

export type TChangePlacingTypeAction = IReduxAction<typeof CHANGE_PLACING_TYPE, EPlacingType | null>;

export const changePlacingType = actionGenerator<typeof CHANGE_PLACING_TYPE, EPlacingType | null>(CHANGE_PLACING_TYPE);
